<template>
	<div class="clothes" :class="{'isiOSX':isiOSX}">
		<van-nav-bar v-if="isApp" title="奢侈品合伙人招募" :fixed="true"/>
    	<img v-if="isApp" @click="goBack()" class="reback" src="../../assets/myInvest/reback.png">
    	<img v-if="isApp" @click="applyMerchantShare()" class="share" src="../../assets/common/xb_title_share.png">
		<van-row>
			<van-col span="24" class="content" :style="paddT">
         		<img src="../../assets/advDetail/fushi/luxury_top@2x.png" />
				<img src="../../assets/advDetail/fushi/luxury_middle@2x.png" />
				<img src="../../assets/advDetail/fushi/luxury_bottom@2x.png" />
				<p>
					<a class="btn" href="tel:13065887776" @click="iOStel()">
						<img src="../../assets/advDetail/fushi/luxury_phone@2x.png">
					</a>
					<span class="btn">
    					<img class="apply" @click="consultation()" src="../../assets/advDetail/fushi/luxury_apply@2x.png">
					</span>
				</p>
			</van-col>
		</van-row>
	</div>
</template>

<script>
export default {
  data() {
    return {
    	isApp: true,
    	tel: '',
    	isiOSX: false,
    	paddT: {paddingTop: '68px'} //app内
    };
  },
  created(){
  	this.isiOSX = this.isIphoneX();
  	if(this.$route.query.from) {//app外
  		this.isApp = false;
  		this.paddT = {paddingTop: '0'}
  	}else {
  		if(this.isiOSX) {//app内齐刘海
  			this.paddT = {paddingTop: '88px'}
  		}
  	}
  },
  methods: {
  	goBack() {
  		this.params('', '', 'goBack');
  	},
	consultation() {
	    this.$router.push({
          path: "/advDetail/applyFor",
          query: {
            type: this.$route.query.type
          }
        });
	},
	iOStel() {
		let ua = navigator.userAgent.toLowerCase();
		if (/iphone|ipad|ipod|macintosh/i.test(ua) && !this.$route.query.from) {
	        this.phone();
	    }
	},
	phone() {
		this.tel = '13065887776';
		this.params(this.tel, this.tel, 'phone');
	},
    applyMerchantShare() {
    	this.params('', '', 'applyMerchantShare');
    }
  },
  mounted() {
	
  }
};
</script>

<style lang="less">
.clothes {
	background: #f5f5f5;
	min-height: 100%;
	.van-nav-bar {
	    height: 44px;
	    line-height: 44px;
	    padding-top: 24px;
	    box-shadow: 0 1px 0 #eee;
	    .van-nav-bar__title {
	      color: #333;
	      font-size: 17px;
	      font-weight: 700;
	    }
	}
	.reback {
	    width: 15px;
	    padding: 12px 15px;
	    position: fixed;
	    top: 27px;
	    left: 0;
	    z-index: 1;
	}
	.share {
		width: 15px;
	    padding: 12px 15px;
	    position: fixed;
	    top: 27px;
	    right: 0;
	    z-index: 1;
	}
	.content{
		background: #ffd0e0;
		position: relative;
		img{
			width: 100%;
			display: block;
		}
		p{
			width: 100%;
			position: absolute;
			left: 0;
			bottom: 0;
			padding: 0 15px 20px;    
			box-sizing: border-box;
			.btn{
				display: inline-block;
				width: 50%;
				padding: 0 15px;
				float: left;
				box-sizing: border-box;
				text-align: center;
				img {
					width: 100%;
					display: inline-block;
				}
			}
		}
	}
}

.isiOSX {
	.van-nav-bar {
		padding-top: 44px;
	}
	.reback {
		top: 47px;
	}
	.share {
		top: 47px;
	}
}


</style>
